import { genCustomerState } from '@web-mail/state/slice/customerMailReducer/states';
import { sliceStateCheck } from '@web-mail/utils/slice';
import { filterTabMap } from '@web-mail/common/constant';
import { tabId } from '@web-common/state/reducer/mailTabReducer';
export const customerReducers = {
    doCreateNewSlice_cm(state, action) {
        const { sliceId } = action.payload;
        if (!state.customer[sliceId]) {
            state.customer[sliceId] = genCustomerState();
        }
    },
    doRemoveSlice_cm(state, action) {
        const { sliceId } = action.payload;
        if (state.customer[sliceId]) {
            delete state.customer[sliceId];
        }
    },
    doCleanTabs_cm(state) {
        const mainState = state.customer[tabId.readCustomer];
        state.customer = {
            [tabId.readCustomer]: mainState,
        };
    },
    doUpdateSliceAny_cm(state, action) {
        const { sliceId, name, data } = action.payload;
        const isSliceExist = sliceStateCheck(state, sliceId, 'customer');
        if (isSliceExist) {
            if (name) {
                try {
                    if (!state.customer[sliceId]) {
                        state.customer[sliceId] = genCustomerState();
                    }
                    state.customer[sliceId][name] = data;
                }
                catch (e) {
                    console.warn('[customer doUpdateSliceAny Error]', name, e);
                }
            }
            else {
                console.warn('[customer doUpdateSliceAny Error]', name);
            }
        }
    },
    doUpdateSelectedSearchContacts_cm: (state, action) => {
        const { sliceId, data } = action.payload;
        const isSliceExist = sliceStateCheck(state, sliceId, 'customer');
        if (isSliceExist) {
            state.customer[sliceId].selectedSearchContacts = data;
        }
    },
    doUpdateSelectedContacts_cm: (state, action) => {
        const { sliceId, data } = action.payload;
        const isSliceExist = sliceStateCheck(state, sliceId, 'customer');
        if (isSliceExist) {
            state.customer[sliceId].selectedContacts = data;
        }
    },
    doUpdateCustomerTreeListById_cm: (state, action) => {
        const { sliceId, data: payloadData } = action.payload;
        const isSliceExist = sliceStateCheck(state, sliceId, 'customer');
        if (isSliceExist) {
            const { id, data, isSearching } = payloadData;
            if (isSearching) {
                const index = state.customer[sliceId].searchTreeList.findIndex(v => v.key === id);
                if (index > -1) {
                    state.customer[sliceId].searchTreeList[index] = data;
                }
            }
            else {
                const index = state.customer[sliceId].customerTreeList.findIndex(v => v.key === id);
                if (index > -1) {
                    state.customer[sliceId].customerTreeList[index] = data;
                }
            }
        }
    },
    doStartMailSearch_cm: (state, action) => {
        const { sliceId, data } = action.payload;
        const isSliceExist = sliceStateCheck(state, sliceId, 'customer');
        if (isSliceExist) {
            state.customer[sliceId].mailSearchKey = data;
            state.customer[sliceId].scrollTop = 0;
            state.customer[sliceId].selectedSearchKeys = { id: '' };
            state.customer[sliceId].expandedSearchKeys = [];
            state.customer[sliceId].mailTabs = filterTabMap.customer;
            state.customer[sliceId].searchList = [];
            state.customer[sliceId].searchTotal = 0;
            state.customer[sliceId].searchListStateTab = 'ME';
            state.customer[sliceId].mailListTabMenuSearch = 'ALL';
            state.customer[sliceId].selectedMailId = { id: '' };
        }
    },
    doResetMailSearch_cm: (state, action) => {
        const { sliceId } = action.payload;
        const isSliceExist = sliceStateCheck(state, sliceId, 'customer');
        if (isSliceExist) {
            state.customer[sliceId].mailSearching = '';
            state.customer[sliceId].mailSearchStateMap = {};
            state.customer[sliceId].selectedSearchKeys = { id: '' };
            state.customer[sliceId].expandedSearchKeys = [];
            state.customer[sliceId].searchTreeList = [];
            state.customer[sliceId].searchTotal = 0;
            state.customer[sliceId].searchList = [];
            state.customer[sliceId].searchListStateTab = 'ME';
            state.customer[sliceId].mailListTabMenuSearch = 'ALL';
            state.customer[sliceId].customerSearchListLoading = false;
            state.customer[sliceId].searchTreeListHasMore = true;
            state.customer[sliceId].searchValue = '';
        }
    },
    updateCustomerAsideDetail_cm: (state, action) => {
        const { sliceId, data } = action.payload;
        const isSliceExist = sliceStateCheck(state, sliceId, 'customer');
        if (isSliceExist) {
            state.customer[sliceId].customerAsideDetail = Object.assign(Object.assign({}, state.customer[sliceId].customerAsideDetail), data);
        }
    },
};
